export enum MetaConst {
  Home = 'ABC Talkies – Online Movies Platform. Submit Your Film',
  HomeDec = 'ABC Talkies - A Platform for Filmmakers to Submit Film or Unreleased Movies',
  I_AM_FILM_MAKER = 'Submit Your Film On ABC Talkies for Free & Monetize Your Work',
  I_AM_FILM_MAKER_DESC = 'Free for All Filmmakers. A Platform That Gives Unreleased Movies a Chance. World’s first open access platform to host your films',
  AboutUs = 'About ABC Talkies - World’s First Cinema Marketplace.',
  AboutUsDesc = 'Best Online Movies Platform to Submit Your Film & Watch Unreleased Movies',
  ContactUs = 'ABC Talkies – Contact Us',
  ContactUsDesc = 'Contact ABC Talkies to publish your short/full length film. online movie platform. Submit your film on ABC Talkies, the best online movie platform.',
  CookiePolicy = 'Cookie Policy',
  CookiePolicyDesc = 'This is Cookie Policy page',
  CopyrightPolicy = 'Copyright Policy',
  CopyrightPolicyDesc = 'This is copyright policy page',
  e_Wallet_Terms = 'e-wallet Terms & conditions',
  e_Wallet_Terms_Desc = 'This is e-wallet Terms & conditions page',
  FilmContestTerms = 'ABC Talkies Film Contest Terms & Conditions. Upload Films, submit your short/full length feature film',
  FilmMakerTerms = 'ABC Talkies Filmmaker Terms & Conditions. Upload Films, submit your short/full length feature film',
  // tslint:disable-next-line:max-line-length
  FilmMakerTermsDesc = 'Before you submit your short/full length feature film on ABC Talkies Read the terms and conditions for filmmakers',
  PaymentRefundPolicy = 'ABC Talkies-Payment Refund Policy',
  PaymentRefundPolicyDesc = 'In case you are looking to opt for the refund of your payment on ABC Talkies, visit this page.',
  PrivacyPolicy = 'ABC Talkies Privacy Policy. Watch Unreleased Movies Online.',
  PrivacyPolicyDesc = 'The information we collect includes personal information, which can have different meanings depending on applicable law',
  UserTermsCondition = 'ABC Talkies User Term & Conditions. Unreleased movies website',
  UserTermsConditionDesc = 'A cookie is a small text file that is stored in your web browser that allows ABC Talkies or a third party to recognize you using a unique identifier',
}

export enum EventType {
  api = 'API Success',
  apiError = 'API Error',
  click = 'Click',
  log = 'Log',
  error = 'Error',
  generalError = 'General Error',
  page = 'Page open',
  dialog = 'Dialog open',
  payment = 'Payment',
  screen = 'Screen Change',
  success = 'Success',
}
